import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

/**
 * Tiny clickable copy-to-clipboard icon.
 * Falls back to a textarea trick when navigator.clipboard isn't available.
 */
export default function CopyButton({ value, label = "", testid, size = 12, className = "" }) {
  const [copied, setCopied] = useState(false);
  const copy = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const text = String(value ?? "");
    if (!text) return;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      toast.success(label ? `${label} copied` : "Copied", { description: text.slice(0, 60) });
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Copy failed");
    }
  };
  const Icon = copied ? Check : Copy;
  return (
    <button
      onClick={copy}
      data-testid={testid}
      title={label ? `Copy ${label}` : "Copy"}
      className={`inline-flex items-center justify-center text-zinc-400 hover:text-zinc-900 transition-colors ${className}`}
    >
      <Icon style={{ width: size, height: size }} />
    </button>
  );
}
